import { c as _c } from "react/compiler-runtime";
import { FaroBulkDialog } from "@components/common/faro-table/bulk-dialog/bulk-dialog";
import { BulkSuccessDialog } from "@components/common/faro-table/bulk-dialog/bulk-success-dialog";
import { useRemoveFromProjectsBulkDialogContent } from "@components/table/member-group-projects/bulk-actions/bulk-remove-from-projects-helper";
import { getTeamAssignedExclusions } from "@components/table/member-group-projects/bulk-actions/team-assignment-exclusion";
import { REMOVE_MEMBER_THROUGH_TEAM_MESSAGE } from "@src/constants/team-constants";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { setBulkActionName, updateMany } from "@store/table/table-slice";
import { selectedRowIdsSelector, shouldShowSuccessDialogSelector } from "@store/table/table-selector";
import { isProjectAssignedThroughTeam } from "@utils/data-display";
import { BulkActionEvents } from "@utils/track-event/track-event-list";
import { useEffect, useMemo } from "react";
import { removeMemberFromProject } from "@store/projects/projects-slice-thunk";
/** Dialog for bulk removing a member/team from selected projects */
export function BulkRemoveFromProjectsDialog(t0) {
  const $ = _c(31);
  const {
    isOpen,
    onClose,
    member,
    projects,
    onSuccessfulComplete
  } = t0;
  const companyId = useCompanyId();
  const dispatch = useAppDispatch();
  const shouldShowSuccessDialog = useAppSelector(shouldShowSuccessDialogSelector);
  const selectedRowIds = useAppSelector(selectedRowIdsSelector);
  let t1;
  if ($[0] !== projects || $[1] !== selectedRowIds) {
    let t2;
    if ($[3] !== selectedRowIds) {
      t2 = p => selectedRowIds.includes(p.id);
      $[3] = selectedRowIds;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = projects.filter(t2);
    $[0] = projects;
    $[1] = selectedRowIds;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectedProjects = t1;
  const {
    bulkDialogContent,
    successDialogContent
  } = useRemoveFromProjectsBulkDialogContent(member);
  let t2;
  let t3;
  if ($[5] !== isOpen || $[6] !== onClose || $[7] !== shouldShowSuccessDialog) {
    t2 = () => {
      if (shouldShowSuccessDialog && isOpen) {
        onClose();
      }
    };
    t3 = [shouldShowSuccessDialog, isOpen, onClose];
    $[5] = isOpen;
    $[6] = onClose;
    $[7] = shouldShowSuccessDialog;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[10] !== dispatch || $[11] !== isOpen || $[12] !== selectedProjects) {
    t4 = () => {
      if (isOpen) {
        dispatch(setBulkActionName("removeMemberFromProject"));
        const exclusions = getTeamAssignedExclusions(selectedProjects, REMOVE_MEMBER_THROUGH_TEAM_MESSAGE);
        if (exclusions.length) {
          dispatch(updateMany(exclusions));
        }
      }
    };
    t5 = [isOpen, dispatch, selectedProjects];
    $[10] = dispatch;
    $[11] = isOpen;
    $[12] = selectedProjects;
    $[13] = t4;
    $[14] = t5;
  } else {
    t4 = $[13];
    t5 = $[14];
  }
  useEffect(t4, t5);
  let t6;
  if ($[15] !== companyId || $[16] !== dispatch || $[17] !== member) {
    t6 = async function onRemoveConfirmed(project) {
      await dispatch(removeMemberFromProject({
        companyId,
        projectId: project.id,
        member
      })).unwrap();
    };
    $[15] = companyId;
    $[16] = dispatch;
    $[17] = member;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const onRemoveConfirmed = t6;
  let t7;
  if ($[19] !== onSuccessfulComplete || $[20] !== selectedProjects) {
    t7 = function handleSuccessfulComplete() {
      const removedProjectIds = selectedProjects.filter(_temp).map(_temp2);
      onSuccessfulComplete(removedProjectIds);
    };
    $[19] = onSuccessfulComplete;
    $[20] = selectedProjects;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const handleSuccessfulComplete = t7;
  if (!isOpen) {
    let t8;
    if ($[22] !== shouldShowSuccessDialog || $[23] !== successDialogContent) {
      t8 = shouldShowSuccessDialog ? <BulkSuccessDialog dialogContent={successDialogContent} /> : null;
      $[22] = shouldShowSuccessDialog;
      $[23] = successDialogContent;
      $[24] = t8;
    } else {
      t8 = $[24];
    }
    return t8;
  }
  let t8;
  if ($[25] !== bulkDialogContent || $[26] !== handleSuccessfulComplete || $[27] !== onClose || $[28] !== onRemoveConfirmed || $[29] !== selectedProjects) {
    t8 = <FaroBulkDialog dialogContent={bulkDialogContent} onClose={onClose} bulkActionCallback={onRemoveConfirmed} onSuccessfulComplete={handleSuccessfulComplete} trackingEvent={BulkActionEvents.bulkRemoveMemberFromProject} selectedEntities={selectedProjects} uniqueIdKey="id" tableDataType="projects" />;
    $[25] = bulkDialogContent;
    $[26] = handleSuccessfulComplete;
    $[27] = onClose;
    $[28] = onRemoveConfirmed;
    $[29] = selectedProjects;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
}
function _temp2(project_1) {
  return project_1.id;
}
function _temp(project_0) {
  return !isProjectAssignedThroughTeam(project_0);
}